import {
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';
import {
  getApiSettingsGetFormWorkflowSettings,
  getApiFormWorkflowGetWorkflowPdfsFormWorkflowId,
} from 'endpoints';
import {
  FormWorkflowDetailResponseDTO,
  MultiMediaResponseDTO,
  SettingsDTO,
} from 'dtos';
import usePrefetchedData from 'pages/Dashboard/hooks/usePrefetchedData';
import {
  normalizeFilterableSettings,
} from 'core/Filters/util';
import {
  getFormWorkflowDetail,
} from 'pages/Dashboard/pages/Forms/pages/FormWorkflow/transport';
import {
  isNoAccessError,
} from 'utils/errors';

export function useFormWorkflowDetail(
  formWorkflowId: number,
): UseQueryResult<FormWorkflowDetailResponseDTO, Error> {
  return useQuery<FormWorkflowDetailResponseDTO, Error>({
    queryKey: ['form-workflow-detail', formWorkflowId],
    queryFn: () => getFormWorkflowDetail(formWorkflowId),
    enabled: formWorkflowId > 0,
    throwOnError: isNoAccessError,
  });
}

export function useFormWorkflowPdfs(
  formWorkflowId: number,
  enabled: boolean = true,
): UseQueryResult<MultiMediaResponseDTO, Error> {
  return useQuery({
    queryKey: ['form-workflow-pdfs', formWorkflowId],
    queryFn: () => getApiFormWorkflowGetWorkflowPdfsFormWorkflowId(formWorkflowId),
    enabled: enabled && formWorkflowId > 0,
  });
}

export function useFormWorkflowFilterMetadata() {
  const { data } = usePrefetchedData<SettingsDTO>({
    key: ['form-workflow-settings'],
    fetchFn: getApiSettingsGetFormWorkflowSettings,
  });

  return normalizeFilterableSettings(data?.filterableSettings ?? []);
}
